import { render, staticRenderFns } from "./RequestExchangeConfirm.vue?vue&type=template&id=83613824&scoped=true&"
import script from "./RequestExchangeConfirm.vue?vue&type=script&lang=js&"
export * from "./RequestExchangeConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RequestExchangeConfirm.vue?vue&type=style&index=0&id=83613824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83613824",
  null
  
)

export default component.exports